import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster} from '/theme/color/on.color';
import {gallery} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: alabaster,
    borderRadius: 8,
    paddingHorizontal: indent * 0.8,
    paddingVertical: indent * 0.6,
    marginBottom: indent * 0.4,
  },
  selectedBase: {
    backgroundColor: gallery,
  },
  colorIndicator: {
    width: 16,
    height: 16,
    borderRadius: 4,
    marginRight: indent * 0.4,
  },
  titleContainer: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
  },
  title: {
    flex: 1,
  },
});
